"use client";
import * as React from "react";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import { SessionProvider } from "next-auth/react";
import { LinguiClientProvider } from "@/utils/providers/LinguiClientProvider";
import { theme } from "@/styles/theme";
import type { Messages } from "@lingui/core";
import "@fontsource/inter";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { getQueryClient } from "@/hooks/get-query-client";

type ClientWrapperProps = {
  children: React.ReactNode;
  initialLocale: string;
  initialMessages: Messages;
};

const ClientWrapper: React.FC<ClientWrapperProps> = ({
  children,
  initialLocale = "de",
  initialMessages,
}) => {
  const queryClient = React.useMemo(() => {
    return getQueryClient();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <LinguiClientProvider initialLocale={initialLocale} initialMessages={initialMessages}>
              {children}
            </LinguiClientProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </SessionProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};

export default ClientWrapper;
